import React from "react";
import { AddExtra } from "./Expand.styled";
import { AddIcon } from "../../Icons";
import { SlideInOut } from "../../../styles/animations";

export const Expand = ({ show, setShow, children, text, marginTop = 0 }) => {
  return (
    <>
      <SlideInOut isOpen={!show} marginTop="0">
        <AddExtra onClick={() => setShow(true)}>
          <span>
            <AddIcon strokeWidth={2} size="15" color="#1e22ff" />
          </span>
          <p>{text}</p>
        </AddExtra>
      </SlideInOut>
      <SlideInOut isOpen={show} marginTop={marginTop} vertical={{ open: 0, closed: 0 }}>
        {children}
      </SlideInOut>
    </>
  );
};
